export const iconFontAwesomeLogisticsTruckPlane = (
	<i className="fa-solid fa-truck-plane"></i>
);
